import { Organization } from '@consigli/types';
import { BsThreeDots } from 'react-icons/bs';

import { ActionButton } from '@/components';

interface OrganizationsActionButtonProps {
  organization: Organization;
  onViewDetails: (organization: Organization) => void;
  onEdit: (organization: Organization) => void;
}

export const OrganizationsActionButton = ({
  organization,
  onViewDetails,
  onEdit,
}: OrganizationsActionButtonProps) => {
  const actions = [
    { label: 'Edit', onClick: () => onEdit(organization) },
    { label: 'View Details', onClick: () => onViewDetails(organization) },
  ];
  return <ActionButton actions={actions} icon={<BsThreeDots />} />;
};
